import React from 'react';

/**
 * Renders the bell (notification) icon SVG with a white border layout.
 */
const Bell = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
    <g>
      <path
        style={{
          fill: 'none', stroke: 'white', strokeWidth: 0.75, strokeMiterlimit: 10,
        }}
        d="M18.31,8.7a1.7,1.7,0,0,1,3.39,0"
      />
      <path
        style={{
          fill: 'none', stroke: 'white', strokeWidth: 0.75, strokeMiterlimit: 10,
        }}
        d="M29.5,25.76V17.85A9.58,9.58,0,0,0,20,8.24h0a9.58,9.58,0,0,0-9.5,9.61v7.91"
      />
      <path
        style={{
          fill: 'none', stroke: 'white', strokeWidth: 0.75, strokeMiterlimit: 10,
        }}
        d="M31.32,29.61H8.68a.34.34,0,0,1-.3-.49l2-3.62H29.61l2,3.62A.34.34,0,0,1,31.32,29.61Z"
      />
      <path
        style={{
          fill: 'none', stroke: 'white', strokeWidth: 0.75, strokeMiterlimit: 10,
        }}
        d="M23.5,30.05a3.5,3.5,0,1,1-7,0"
      />
    </g>
  </svg>
);

export default Bell;
